/* eslint-disable @typescript-eslint/no-non-null-asserted-optional-chain */
import { SecondaryButton } from '@components/Button'
import Loading from '@components/Loading'
import useRealm from '@hooks/useRealm'
import { BN } from '@coral-xyz/anchor'
import { useState } from 'react'
import useWalletOnePointOh from '@hooks/useWalletOnePointOh'
import DepositInDaoModal from './modals/DepositInDaoModal'

const DepositCommunityTokensBtn = ({ className = '', inAccountDetails }) => {
  // const { getOwnedDeposits } = useDepositStore()
  // const realm = useRealmQuery().data?.result

  const {
    // realmInfo,
    realmTokenAccount,
  } = useRealm()
  // const client = useVotePluginsClientStore((s) => s.state.vsrClient)
  const [
    isLoading,
    // setIsLoading
  ] = useState(false)
  const wallet = useWalletOnePointOh()
  const connected = !!wallet?.connected
  // const { connection } = useConnection()
  // const endpoint = connection.rpcEndpoint
  // const currentTokenOwnerRecord = useUserCommunityTokenOwnerRecord().data
  //   ?.result

  // const depositAllTokens = async function () {
  //   if (!realm) {
  //     throw 'No realm selected'
  //   }
  //   setIsLoading(true)
  //   const tokenOwnerRecordPk =
  //     typeof currentTokenOwnerRecord !== 'undefined'
  //       ? currentTokenOwnerRecord.pubkey
  //       : null
  //   const rpcContext = new RpcContext(
  //     realm.owner,
  //     getProgramVersionForRealm(realmInfo!),
  //     wallet!,
  //     connection,
  //     endpoint
  //   )
  //   try {
  //     await voteRegistryDepositWithoutLockup({
  //       rpcContext,
  //       fromPk: realmTokenAccount!.publicKey,
  //       mintPk: realm.account.communityMint!,
  //       realmPk: realm.pubkey,
  //       programId: realm.owner,
  //       programVersion: realmInfo?.programVersion!,
  //       amount: realmTokenAccount!.account.amount,
  //       tokenOwnerRecordPk,
  //       client: client,
  //       communityMintPk: realm.account.communityMint,
  //     })
  //     await getOwnedDeposits({
  //       realmPk: realm!.pubkey,
  //       communityMintPk: realm!.account.communityMint,
  //       walletPk: wallet!.publicKey!,
  //       client: client!,
  //       connection,
  //     })
  //     queryClient.invalidateQueries(
  //       tokenAccountQueryKeys.byOwner(
  //         connection.rpcEndpoint,
  //         wallet!.publicKey!
  //       )
  //     )
  //   } catch (e) {
  //     console.log(e)
  //     notify({ message: `Something went wrong ${e}`, type: 'error' })
  //   }
  //   setIsLoading(false)
  // }

  const hasTokensInWallet =
    realmTokenAccount && realmTokenAccount.account.amount.gt(new BN(0))

  const depositTooltipContent = !connected
    ? 'Connect your wallet to deposit'
    : !hasTokensInWallet
    ? "You don't have any governance tokens in your wallet to deposit."
    : ''

  const [isOpen, setIsOpen] = useState(false)

  return hasTokensInWallet || inAccountDetails ? (
    <>
      <SecondaryButton
        tooltipMessage={depositTooltipContent}
        className={`sm:w-1/2 ${className}`}
        disabled={!connected || !hasTokensInWallet || isLoading}
        // onClick={depositAllTokens}
        onClick={() => setIsOpen(true)}
      >
        {isLoading ? <Loading /> : 'Deposit'}
      </SecondaryButton>

      {isOpen && <DepositInDaoModal isOpen={isOpen} setIsOpen={setIsOpen} />}
    </>
  ) : null
}

export default DepositCommunityTokensBtn
